'use strict';

import 'core-js/es6/set';
import 'core-js/es6/map';
import 'core-js/es6/symbol';
import 'core-js/es6/promise';
import 'core-js/es6/object';
import 'core-js/es6/array';

import jQuery from 'jquery';
import placeholder from './../../vendor/jquery.placeholder.min';

import browser from './../../vendor/jquery.browser.min';
import validate from './../../vendor/jquery.validate';
import Blocks from './../Blocks/Blocks';
import config from './../Config/Config';
import ga from './../../vendor/google-analytics';
import fbq from './../../vendor/facebook-pixel';
import genoo from './../../vendor/genoo';
import GoogleTagAdLoader from './../Ads/GoogleTagAdLoader';
import Header from './../Header/Header';
import MobilePersistentAd from './../Ads/MobilePersistentAd';
import Utilities from './../Utilities/Utilities';
import PassportUser from './../User/PassportUser';
import Forms from './Forms';
import quantcast from './../../vendor/quantcast';
import RedPoint from './../../vendor/redpoint';
import AutoplayCookie from './../Autoplay/Autoplay';
import windowGlobals from './../Export/window';
import _throttle from 'lodash.throttle';
import adwords from './../../vendor/adwords';

// Polyfill Object.assign
import poly from './ObjectAssignPolyfill';

var Core = (function ($) {
  return function (options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      },
      $toTop: $('.to-top'),
      previousScroll: 0,
      toTopShown: false
    };

    // Namespace for public variables and functions
    var publicNS = {
      ASSETS_URL: '/content/themes/tpt/dist/images/'
    };

    /**
     * Construct a new instance
     */
    privateNS.init = function () {

      // Store a reference to the document head element
      privateNS.head = document.getElementsByTagName('head');

      // Create a store of configuration settings for the environment
      publicNS.config = config;

      if ('serviceWorker' in navigator) {
        window.addEventListener('load', function () {
          navigator.serviceWorker.register(`/content/themes/tpt/dist/${process.env.NODE_ENV === 'production' ? 'build' : 'debug'}/js/service-worker.js`);
        });
      }

      // Create and instance for the current end user
      publicNS.user = new PassportUser();

      // If it is available, augment the jquery browser plugin with a
      // couple helper matches
      if (typeof $.browser === 'object') {

        // Define these platforms as iOS
        $.browser.ios = $.browser.platform === 'ipad' ||
          $.browser.platform === 'iphone' ||
          $.browser.platform === 'ipod';
      }

      // Alias browser to the Core module
      publicNS.browser = $.browser;

      // Create an instance of the GoogleTagAdLoader
      publicNS.googleAds = GoogleTagAdLoader;

      // Check to make sure there is a head element to get the account id from
      if (privateNS.head.length > 0) {

        // Try to extract the ads account id from the head
        var adAccountId = privateNS.head[0].getAttribute('data-ad');

        // Make sure an id was found
        if (adAccountId !== null) {

          // Initialize the ad loader with the ad account id
          publicNS.googleAds = publicNS.googleAds({
            accountId: adAccountId
          });
        }
      }

      // Create an instance of the Header
      publicNS.header = Header;

      // Create an accessor for the common Blocks code
      publicNS.blocks = Blocks;

      // Create an accessor for the AutoplayCookie
      publicNS.AutoPlayCookie = AutoplayCookie;

      // Create an instance of the Utilities
      publicNS.utils = Utilities;

      // Re-validate the user and schedule further re-validation of the user's
      // session every 5 minutes
      publicNS.user.revalidateOnInterval(1000 * 60 * 5);

      // Create a reference to the Mobile Persistent Ad class
      publicNS.MobilePersistentAd = MobilePersistentAd;

      // Get any AJAX forms that need to be handled.
      privateNS.$ajaxForms = $('body').find('.ajax-form');

      $(privateNS.$ajaxForms).each(function (i, el) {
        $(el).validate({
          onsubmit: false,
          invalidHandler: function (event, validator) {
            var errors = validator.numberOfInvalids();

            if (errors) {
              var errorEl = validator.errorList[0].element;
              errorEl.focus();
              $(window).scrollTop($(errorEl).offset().top - $('#body-wrapper div:first-child').offset().top);
            }
          }
        });
        $(el).submit(privateNS.onAjaxFormSubmit);
      });

      // Wrap all iframes in the WordPress content body with a responsive wrapper
      publicNS.utils.wrapIFrame(document.getElementsByClassName('responsive-content'));
      publicNS.utils.wrapIFrame(document.getElementsByClassName('block'));

      // Execute the traditional placeholder polyfill across non searchbox input
      $('input, textarea').not('.search-field').placeholder();

      // Set a filtered list of anchor tags to open in new windows
      $('a').
        filter(function filterOutNonHTTP(index, element) {

          // Remove any anchors that do not link to http or https sources
          return element.protocol === 'http' || element.protocol === 'https';
        }).
        filter(function filterOutInternalLinks(index, element) {

          // Remove any anchors that have the current hostname as their hostname
          return element.hostname !== document.location.hostname;
        }).
        filter(function filterOutPBSSignOnLinks(index, element) {

          // Remove any anchors that have the PBS Sign On as their hostname
          return !(element.hostname === 'account.pbs.org' ||
            element.hostname === 'account-qa.pbs.org');
        }).
        attr('target', '_blank');

      // Set all anchor tags ending in .pdf to open in a new window
      $('a[href$=".pdf"]').attr('target', '_blank');


      // Make sure a head tag was found
      if (privateNS.head.length > 0) {

        // Handle url tracking overrides. If an override is defined for the page,
        // track the initial pageview to that url rather then the default one
        // decide by Google Analytics

        // Extract the tracking override from the document head
        var trackingOverride = privateNS.head[0].getAttribute('data-tracking');

        // Make sure a tracking override was found
        if (trackingOverride !== null) {

          // If this is a show page then an override will be set. Check to see
          // if the url also contains a url fragment for an episode
          if (trackingOverride.match(/show\/[a-zA-Z0-9\-]+/) !== null &&
            location.hash.match(/#\/episode\/[a-zA-Z0-9\-]+/) !== null) {

            // This show page has a url fragment associated with it and should
            // track to that episode url rather than the page url
            trackingOverride = trackingOverride + location.hash.slice(2) + '/';
          }
        }

        // If a tracking override was found, set the ga page to it
        if (trackingOverride) {
          let trackUrl = publicNS.utils.buildTrackingURL(trackingOverride);

          ga('set', 'location', trackUrl);
          ga('set', 'page', trackingOverride + location.hash);

          genoo('set', 'location', trackUrl);
        }
      }

      if (publicNS.user.getUuid()) {
        ga('set', 'userId', publicNS.user.getUuid());
      }

      // Finally track a pageview
      publicNS.trackPageView();

      // Initialize forms
      Forms.init();

      // Create a new mobile persistent ad in the footer
      privateNS.bottomMobilePersistentAd = new publicNS.MobilePersistentAd({
        container: '#bottom-mobile-persistent'
      });

      $(window).scroll(_throttle(function () {
        var currentScroll = $(window).scrollTop();

        if (privateNS.previousScroll > currentScroll && currentScroll > 100) {
          privateNS.$toTop.addClass('active');

          if (!privateNS.toTopShown) {
            privateNS.toTopShown = true;
            ga('send', 'event', 'back to top', 'displayed', location.href);
          }
        } else {
          privateNS.$toTop.removeClass('active');
        }

        privateNS.previousScroll = currentScroll;
      }, 200)
      );

      privateNS.$toTop.click(function (e) {
        e.preventDefault();

        ga('send', 'event', 'back to top', 'clicked', location.href);
        $('html, body').animate({ 'scrollTop': 0 });
      });

      // Return the public namespace
      return publicNS;
    };

    /**
     * Tracks a page view to the remote tracking servers. If a tracking override
     * url is specified in the page, then that is used instead of the page's url
     */
    publicNS.trackPageView = function trackPageView() {

      // Perform GA tracking
      ga('send', 'pageview');

      // Track the current page to Facebook
      fbq('track', 'PageView');

      // Track to Genoo
      genoo('send', 'pageview');
    };

    /**
     * Initializes the appropriate block code for each of the blocks on
     * the page
     *
     * @param {jQuery} $blocks A jQuery object containing the blocks that
     *                         need to be initialized
     */
    publicNS.initBlocks = function initBlocks($blocks) {

      // For each block, look for a corresponding Block class to initialize
      $blocks.each(function mapToBlock() {

        // Get the block type
        var $block = $(this),
          blockType = $block.attr('data-block-type');

        // If there is a class defined in the core for this block type then
        // initialize a new one with this block
        if (blockType) {

          // Try to get the block object
          var blockObject = blockType.charAt(0).toUpperCase() + blockType.substr(1);

          // If the block object exists, make a new one
          if (publicNS.blocks[blockObject]) {
            publicNS.blocks[blockObject]({
              container: $block
            });
          }
        }
      });
    };

    /**
     * Does handling of AJAX form submissions.
     *
     * @param Event e
     */
    privateNS.onAjaxFormSubmit = function (e) {
      var $this = $(this);

      if ($this.valid()) {

        // Don't let them submit more than once.
        var $submitBtn = $this.find('input[type=submit]');

        $submitBtn.attr('disabled', 'disabled');

        // Generate the data for the RedPoint ajax request
        var redpointData = $this.serializeArray().reduce(function (obj, item) {
          obj[item.name] = item.value;
          return obj;
        }, {});

        // Apply the RedPoint form tracking logic
        RedPoint.updateFormTracking();

        // Make the email request to RedPoint
        $.ajax({
          type: 'POST',
          url: window.themosis.ajaxurl, // Global access to the WordPress ajax handler file
          dataType: 'json',
          data: {
            action: 'Page.redPointSubmission',
            form: redpointData
          }
        }).then(function (response) {

          // Allow for overriding the message in a hidden div.
          var $response = $this.find('.response');
          var responseMsg;

          if ($response.length > 0) {
            responseMsg = $response.html();
          } else {
            responseMsg = response.message;
          }

          $this.html('' +
            '<div class="contact-form-submit-message row"><div class="columns"> ' +
            '<strong>' + responseMsg + '</strong>' +
            '</div></div>');

          // Trigger a success event on the Ajax form for anyone listening
          $this.trigger('ajaxformsuccess');
        }).catch(function (response) {

          // Make sure a response was sent
          if (typeof response !== 'undefined') {

            // Parse the response from the server
            var parsedResponse = JSON.parse(response.responseText);
            alert(parsedResponse.message);
          }

          // Always unfreeze the submission button if something goes wrong
          $submitBtn.attr('disabled', '');

          // Trigger a fail event on the Ajax form for anyone listening
          $this.trigger('ajaxformfailed');
        });
      }

      e.preventDefault();
    };

    /**
     * Update the tracking override for the page
     *
     * @param {string} path
     */
    publicNS.updateTrackingPath = function updateTrackingPath(path) {
      if (privateNS.head.length > 0) {
        privateNS.head[0].setAttribute('data-tracking', path);
        let trackUrl = publicNS.utils.buildTrackingURL(path);

        ga('set', 'page', path);
        ga('set', 'location', trackUrl);
        genoo('set', 'location', trackUrl);
      }
    };

    /**
     * Update the page title
     *
     * @param {string} title
     */
    publicNS.updateTitle = function updateTitle(title) {
      document.title = title;
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default new Core();